import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardForDeliveryList extends BaseModelAPI {

	static entity = 'newobject1921list'
	static entityName = 'controlcardfordelivery';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
